import type { Icon } from '@phosphor-icons/react';
import { InformationIconButton } from '@eti/components';
import { TripType } from '@eti/schema-types';
import type { quickSortPricesType } from './quickSortConstants';
import { quickSortType } from './quickSortConstants';

export type QuickSortOptionType = {
  desc?: string;
  labelKey: string;
  value: keyof typeof quickSortPricesType;
};

export const getQuickSortOptions = (t: (arg: string) => string): QuickSortOptionType[] => [
  {
    desc: t('Result.QuickSort.BestSort.Description.Text'),
    labelKey: t('Result.QuickFilter.BestValue.Button'),
    value: quickSortType.BEST_VALUE,
  },
  {
    labelKey: t('Result.QuickFilter.Cheapest.Button'),
    value: quickSortType.CHEAPEST,
  },
  {
    labelKey: t('Result.QuickFilter.Fastest.Button'),
    value: quickSortType.SHORTEST,
  },
];

export const getRecommendedQuickSortOption = (t: (arg: string) => string): QuickSortOptionType => {
  return {
    value: quickSortType.RECOMMENDED,
    labelKey: t('Result.QuickFilter.Recommended.Button'),
    desc: t('Result.QuickSort.SponsoredSort.Description.Text'),
  };
};

export const getLongestQuickSortOption = (t: (arg: string) => string): QuickSortOptionType => {
  return {
    value: quickSortType.LONG_STAY,
    labelKey: t('Result.QuickFilter.Longest.Button'),
  };
};

export const getSortingDropDownOptions = (
  journeyType: TripType,
  t: (text: string) => string | null,
) => {
  const sortingDropdownOptions = [
    {
      id: '3',
      value: quickSortType.RECOMMENDED,
      labelKey: t('Result.QuickFilter.Recommended.Button'),
      desc: t('Result.QuickSort.SponsoredSort.Description.Text'),
      icon: InformationIconButton,
    },
  ] as {
    id: string;
    icon?: Icon;
    value: keyof typeof quickSortPricesType;
    labelKey: string;
    desc?: string;
  }[];

  if (journeyType === TripType.Return) {
    sortingDropdownOptions.push({
      id: '4',
      value: quickSortType.LONG_STAY,
      labelKey: t('Result.QuickFilter.Longest.Button'),
    } as {
      id: string;
      value: keyof typeof quickSortPricesType;
      labelKey: string;
    });
    sortingDropdownOptions.sort((a, b) => a.labelKey.localeCompare(b.labelKey));
  }
  return sortingDropdownOptions;
};
